import { useQueryClient } from "@tanstack/react-query";

export const useQueryCache = () => {
  const queryClient = useQueryClient();
  return queryClient.getQueryCache();
};
